import { defineMessages } from "react-intl";

export const messages = defineMessages({
  sortAndFilter: {
    id: "ari.management.sortAndFilter.title",
    defaultMessage: "Filter and Order",
  },
  roomTypes: {
    id: "ari.management.sortAndFilter.roomTypes",
    defaultMessage: "Room types",
  },
  conditions: {
    id: "ari.management.sortAndFilter.rates",
    defaultMessage: "Rates",
  },
  mealPlans: {
    id: "ari.management.sortAndFilter.mealPlans",
    defaultMessage: "Meal plans",
  },
  occupancies: {
    id: "ari.management.sortAndFilter.occupancies",
    defaultMessage: "Occupancy",
  },
  fields: {
    id: "ari.management.sortAndFilter.fields",
    defaultMessage: "Restrictions",
  },
  orderBy: {
    id: "ari.management.sortAndFilter.orderBy",
    defaultMessage: "Order by",
  },
  rate: {
    id: "ari.management.sortAndFilter.rate",
    defaultMessage: "Rates"
  },
  availability: {
    id: "ari.management.sortAndFilter.availability",
    defaultMessage: "Avail"
  },
  closed: {
    id: "ari.management.sortAndFilter.closed",
    defaultMessage: "Stop sell"
  },
  closeToArrival: {
    id: "ari.management.sortAndFilter.closeToArrival",
    defaultMessage: "CTA"
  },
  closeToDeparture: {
    id: "ari.management.sortAndFilter.closeToDeparture",
    defaultMessage: "CTD"
  },
  minStay: {
    id: "ari.management.sortAndFilter.minStay",
    defaultMessage: "Min Stay"
  },
  maxStay: {
    id: "ari.management.sortAndFilter.maxStay",
    defaultMessage: "Max Stay"
  },
  minNotice: {
    id: "ari.management.sortAndFilter.minNotice",
    defaultMessage: "Min Adv"
  },
  maxNotice: {
    id: "ari.management.sortAndFilter.maxNotice",
    defaultMessage: "Max Adv"
  }
});
